"use client";
import { useState, useEffect, useRef } from "react";
import Layout from "@/components/common/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentToken,
  selectCurrentUser,
} from "@/Redux/features/auth/authSlice";
import {
  getUserChats,
  getMessages,
  sendMessage,
  makeAdmin,
  removeAdmin,
} from "@/Redux/features/chat/chatSlice";
import toast from "react-hot-toast";
import Loading from "@/components/common/loading";
import { formatDistanceToNowStrict, formatDistanceToNow } from "date-fns";
import io from "socket.io-client";
import {
  addMessage,
  updateChatLatestMessage,
} from "@/Redux/features/chat/chatSlice";
import { BsThreeDotsVertical } from "react-icons/bs";
import { RxCross1 } from "react-icons/rx";
import { FaUsers } from "react-icons/fa";

let socket;

export default function ChatPage() {
  const chats = useSelector((state) => state.chat.chats);
  console.log(chats, "chats from inbox page");
  const messages = useSelector((state) => state.chat.messages);
  console.log(messages, "messages from inbox");
  const [selectedChat, setSelectedChat] = useState();
  const [newMessage, setNewMessage] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMemberOpen, setIsMemberOpen] = useState(false);
  const [isMemberOptionsOpen, setIsMemberOptionsOpen] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const currentToken = useSelector(selectCurrentToken);
  const currentUser = useSelector(selectCurrentUser);
  console.log(currentToken, "currentToken");
  const dispatch = useDispatch();
  const containerRef = useRef(null);

  useEffect(() => {
    const socketInstance = io(process.env.NEXT_PUBLIC_BASE_URL, {
      auth: { token: currentToken },
    });

    if (selectedChat?._id) {
      socketInstance.emit("joinChat", selectedChat._id);
    }

    socketInstance.on("newMessage", (msg) => {
      // console.log(msg, 'msg from newMessage')
      if (msg.sender._id === currentUser?._id) return;
      if (selectedChat?._id === msg?.chat?._id) {
        dispatch(addMessage(msg));
      }
      dispatch(
        updateChatLatestMessage({ chatId: msg?.chat?._id, message: msg })
      );
    });

    socket = socketInstance;
    return () => {
      socketInstance.disconnect();
    };
  }, [currentToken, currentUser?.UID, selectedChat?._id, dispatch]);

  useEffect(() => {
    dispatch(getUserChats({ setLoading, token: currentToken }));
  }, []);

  const handleGetMessages = async (chatId) => {
    await dispatch(
      getMessages({ setLoading, chatId, token: currentToken })
    ).unwrap();
    socket.emit("joinChat", chatId);
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!newMessage.trim() || !selectedChat) return;

    try {
      const savedMessage = await dispatch(
        sendMessage({
          chatId: selectedChat?._id,
          content: newMessage.trim(),
          token: currentToken,
        })
      ).unwrap();

      socket.emit("sendMessage", savedMessage);

      setNewMessage("");
    } catch (error) {
      console.error(error);
    }
  };

  const getInitials = (name) => {
    if (!name) return "??";

    // split by "-" or space
    const parts = name.split(/[-\s]+/).filter(Boolean);

    if (parts.length >= 2) {
      // First two parts → take their first letters
      return parts[0][0].toUpperCase() + parts[1][0].toUpperCase();
    } else {
      // Only one word → take first and second char
      const word = parts[0];
      return word[0].toUpperCase() + (word[1] ? word[1].toUpperCase() : "");
    }
  };

  const timeAgo = (time) => {
    return formatDistanceToNowStrict(new Date(time), { addSuffix: true });
  };

  const scrollToBottom = () => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  };

  // Jab bhi messages change ho → last tak scroll
  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleMemberToggle = () => {
    setIsMemberOpen(!isMemberOpen);
  };

  const handleMemberOptionsOpen = (id) => {
    setIsMemberOptionsOpen(!isMemberOptionsOpen);
    setSelectedMemberId(id);
  };

  const handleMakeAdmin = async (memberId, chatId) => {
    await dispatch(
      makeAdmin({ token: currentToken, memberId, chatId: chatId })
    ).unwrap();
    const updatedChats = await dispatch(
      getUserChats({ setLoading, token: currentToken })
    ).unwrap();

    setSelectedChat(
      updatedChats.find((c) => c._id.toString() === chatId.toString())
    );
    setIsMemberOptionsOpen(false);
    setSelectedMemberId(null);
  };

  const handleRemoveAdmin = async (memberId, chatId) => {
    await dispatch(
      removeAdmin({ token: currentToken, memberId, chatId: chatId })
    ).unwrap();
    const updatedChats = await dispatch(
      getUserChats({ setLoading, token: currentToken })
    ).unwrap();

    setSelectedChat(
      updatedChats.find((c) => c._id.toString() === chatId.toString())
    );
    setIsMemberOptionsOpen(false);
    setSelectedMemberId(null);
  };

  return (
    <Layout pageTitle={"Podcast | Inbox"}>
      <div className="flex h-[90vh] bg-background">
        {loading && <Loading />}
        {/* Mobile sidebar overlay */}
        {isSidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}
        {isMemberOpen && (
          <div className="fixed bg-black/50 w-screen h-screen z-50 left-0 top-0 flex justify-center items-center">
            <div className="bg-white w-1/4 rounded-lg py-5 px-24 relative">
              <div className="absolute top-4 right-5">
                <RxCross1
                  className="cursor-pointer"
                  onClick={handleMemberToggle}
                />
              </div>
              <div className="text-center mb-6">
                <h2 className="font-bold text-lg">People</h2>
              </div>
              <div className="admin">
                <div className="flex items-center mb-2">
                  <div className="flex-grow border-t border-gray-300"></div>
                  <span className="px-3 font-semibold text-gray-700 text-base">
                    Admin
                  </span>
                  <div className="flex-grow border-t border-gray-300"></div>
                </div>
                <div className="flex flex-col gap-4">
                  {selectedChat?.members
                    ?.filter(
                      (member) =>
                        member?._id === selectedChat?.createdBy ||
                        selectedChat?.admins?.some(
                          (admin) => admin?._id === member?._id
                        )
                    )
                    ?.map((member, index) => {
                      return (
                        <div
                          key={index}
                          className="flex items-center justify-between relative"
                        >
                          <div>
                            <h4 className="text-semibold">
                              {member?.firstName} {member?.lastName}
                            </h4>
                            <p className="text-sm text-gray-500">
                              {member?.username}
                            </p>
                          </div>

                          {selectedChat?.createdBy !== member?._id &&
                            (selectedChat?.createdBy === currentUser.UID ||
                              selectedChat?.admins?.some(
                                (admin) =>
                                  admin?._id?.toString() ===
                                  currentUser.UID?.toString()
                              )) &&
                            member?._id?.toString() !==
                              currentUser.UID?.toString() && (
                              <div>
                                <BsThreeDotsVertical
                                  className="cursor-pointer"
                                  onClick={() =>
                                    handleMemberOptionsOpen(member?._id)
                                  }
                                />
                                {isMemberOptionsOpen &&
                                  selectedMemberId === member?._id && (
                                    <div
                                      className={`absolute top-[95%] right-0 bg-white shadow-lg rounded-md overflow-hidden py-1 z-[60]`}
                                    >
                                      <li
                                        className="list-none cursor-pointer hover:bg-gray-100 transition-all duration-300 ease-in-out px-4 py-2"
                                        onClick={() =>
                                          handleRemoveAdmin(
                                            member?._id,
                                            selectedChat?._id
                                          )
                                        }
                                      >
                                        Remove Admin
                                      </li>
                                    </div>
                                  )}
                              </div>
                            )}
                        </div>
                      );
                    })}
                </div>
              </div>
              <div className="member">
                {selectedChat?.members?.some((member) => {
                  if (member?._id === selectedChat?.createdBy) return false;

                  const isAdmin = selectedChat?.admins?.some(
                    (admin) =>
                      admin?._id?.toString() === member?._id?.toString()
                  );
                  if (isAdmin) return false;

                  return true;
                }) && (
                  <>
                    <div className="flex items-center mt-7 mb-2">
                      <div className="flex-grow border-t border-gray-300"></div>
                      <span className="px-3 font-semibold text-gray-700 text-base">
                        Member
                      </span>
                      <div className="flex-grow border-t border-gray-300"></div>
                    </div>
                    <div className="flex flex-col gap-4">
                      {selectedChat?.members
                        ?.filter((member) => {
                          // Exclude creator
                          if (member?._id === selectedChat?.createdBy)
                            return false;

                          // Exclude admins
                          const isAdmin = selectedChat?.admins?.some(
                            (admin) =>
                              admin?._id?.toString() === member?._id?.toString()
                          );
                          if (isAdmin) return false;

                          return true;
                        })
                        ?.map((member, index) => {
                          return (
                            <div
                              key={index}
                              className="flex items-center justify-between relative"
                            >
                              <div>
                                <h4 className="text-semibold">
                                  {member?.firstName} {member?.lastName}
                                </h4>
                                <p className="text-sm text-gray-500">
                                  {member?.username}
                                </p>
                              </div>
                              <div>
                                <BsThreeDotsVertical
                                  className="cursor-pointer"
                                  onClick={() =>
                                    handleMemberOptionsOpen(member?._id)
                                  }
                                />
                                {isMemberOptionsOpen &&
                                  selectedMemberId === member?._id && (
                                    <div
                                      className={`absolute top-full right-0 bg-white shadow-lg rounded-md overflow-hidden py-1 z-[60]`}
                                    >
                                      <li
                                        className="list-none cursor-pointer hover:bg-gray-100 transition-all duration-300 ease-in-out px-4 py-2"
                                        onClick={() =>
                                          handleMakeAdmin(
                                            member?._id,
                                            selectedChat?._id
                                          )
                                        }
                                      >
                                        Make Admin
                                      </li>
                                    </div>
                                  )}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Left Sidebar */}
        <div
          className={`${
            isSidebarOpen ? "translate-x-0" : "-translate-x-full"
          } fixed lg:relative lg:translate-x-0 w-80 h-full bg-gray-800 border-r border-gray-400 z-30 transition-transform duration-300 ease-in-out lg:block`}
        >
          {/* Sidebar Header */}
          <div className="p-4 border-b border-sidebar-border">
            <div className="flex items-center justify-between">
              <h1 className="text-xl font-semibold text-white">Messages</h1>
              <button
                onClick={() => setIsSidebarOpen(false)}
                className="lg:hidden p-2 text-white hover:bg-gray-200 rounded-lg"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* Chat List */}
          <div className="overflow-y-auto h-full pb-4">
            {chats?.map((chat) => (
              <ChatListItem
                key={chat?._id}
                chat={chat}
                isActive={selectedChat?._id === chat?._id}
                onSelect={() => {
                  setSelectedChat(chat);
                  setIsSidebarOpen(false);
                }}
                handleGetMessages={handleGetMessages}
              />
            ))}
          </div>
        </div>

        {/* Right Chat Window */}
        {selectedChat ? (
          <div className="flex-1 flex flex-col">
            {/* Chat Header */}
            <div className="p-4 border-b border-gray-200 bg-gray-100 flex items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <button
                  onClick={() => setIsSidebarOpen(true)}
                  className="lg:hidden p-2 text-foreground hover:bg-accent rounded-lg"
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                </button>
                <div className="w-10 h-10 bg-indigo-200 rounded-full flex items-center justify-center">
                  <span className="text-sm font-medium text-indigo-600">
                    {getInitials(selectedChat?.name)}
                  </span>
                </div>
                <div>
                  <h2 className="font-semibold text-foreground">
                    {selectedChat?.name}
                  </h2>
                  <p className="text-sm text-muted-foreground">Active now</p>
                </div>
              </div>
              <div>
                {(selectedChat?.createdBy === currentUser.UID ||
                  selectedChat?.admins?.some(
                    (admin) =>
                      admin?._id?.toString() === currentUser.UID?.toString()
                  )) && (
                  <FaUsers
                    size={26}
                    className="cursor-pointer text-gray-500"
                    onClick={handleMemberToggle}
                  />
                )}
              </div>
            </div>

            {/* Messages */}
            <div
              ref={containerRef}
              className="flex-1 overflow-y-auto scrollbar-hide p-4 space-y-4"
            >
              {messages?.map((message) => (
                <div
                  key={message?._id}
                  className={`flex ${
                    message?.sender?._id !== currentUser.UID
                      ? "justify-end"
                      : "justify-start"
                  }`}
                >
                  <div
                    className={`max-w-xs lg:max-w-md px-4 py-2 rounded-2xl ${
                      message?.sender?._id !== currentUser.UID
                        ? "bg-indigo-500 text-white"
                        : "bg-gray-100 text-black border border-gray-200"
                    }`}
                  >
                    <p className="text-sm">{message?.content}</p>
                    <p
                      className={`text-xs mt-1 ${
                        message?.sender?._id !== currentUser.UID
                          ? "text-gray-300"
                          : "text-muted"
                      }`}
                    >
                      {timeAgo(message?.createdAt)}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Message Input */}
            <div className="p-4 border-t border-border bg-card">
              {selectedChat?.createdBy === currentUser.UID ||
              selectedChat?.admins?.some(
                (admin) =>
                  admin?._id?.toString() === currentUser.UID?.toString()
              ) ? (
                <form onSubmit={handleSendMessage} className="flex gap-2">
                  <input
                    type="text"
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    placeholder="Type a message..."
                    className="flex-1 px-4 py-2 bg-input border border-border rounded-full focus:outline-none text-sm placeholder:text-muted-foreground"
                  />
                  <button
                    type="submit"
                    disabled={!newMessage.trim()}
                    className="px-4 py-2 bg-indigo-400 text-indigo-800 rounded-full hover:bg-indigo-400 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  >
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                      />
                    </svg>
                  </button>
                </form>
              ) : (
                <div className="text-center">Only Admin Can Send Message</div>
              )}
            </div>
          </div>
        ) : (
          <div className="h-full w-full bg-gray-100 flex justify-center items-center">
            <h2 className="font-semibold text-lg text-gray-700">
              Select Chat To See Messages
            </h2>
          </div>
        )}
      </div>
    </Layout>
  );
}

// Chat List Item Component
function ChatListItem({ chat, isActive, onSelect, handleGetMessages }) {
  const timeAgo = chat?.updatedAt
    ? formatDistanceToNow(new Date(chat.updatedAt), { addSuffix: true })
    : "";

  const getInitials = (name) => {
    if (!name) return "??";

    // split by "-" or space
    const parts = name.split(/[-\s]+/).filter(Boolean);

    if (parts.length >= 2) {
      // First two parts → take their first letters
      return parts[0][0].toUpperCase() + parts[1][0].toUpperCase();
    } else {
      // Only one word → take first and second char
      const word = parts[0];
      return word[0].toUpperCase() + (word[1] ? word[1].toUpperCase() : "");
    }
  };
  return (
    <button
      onClick={() => {
        handleGetMessages(chat?._id);
        onSelect();
      }}
      className={`w-full p-4 text-left hover:bg-gray-200 hover:text-black text-white transition-colors ${
        isActive ? "bg-blue-500" : ""
      }`}
    >
      <div className="flex items-center gap-3">
        <div className="relative">
          <div className="w-12 h-12 bg-white text-black rounded-full flex items-center justify-center">
            <span className={`text-sm font-medium`}>
              {getInitials(chat?.name)}
            </span>
          </div>
          {/* {chat.unread && (
            <div className="absolute -top-1 -right-1 w-3 h-3 bg-secondary rounded-full"></div>
          )} */}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-1">
            <h3
              className={`font-medium truncate ${
                isActive
                  ? "text-sidebar-primary-foreground"
                  : "text-sidebar-foreground"
              }`}
            >
              {chat?.name}
            </h3>
            <span
              className={`text-xs ${
                isActive
                  ? "text-sidebar-primary-foreground/70"
                  : "text-sidebar-foreground/70"
              }`}
            >
              {timeAgo}
            </span>
          </div>
          <p
            className={`text-sm truncate ${
              isActive
                ? "text-sidebar-primary-foreground/70"
                : "text-sidebar-foreground/70"
            } ${chat?.unread ? "font-medium" : ""}`}
          >
            {chat?.latestMessage?.content || "No message yet"}
          </p>
        </div>
      </div>
    </button>
  );
}
